import React from "react";
import Modal from "react-modal";
import { useScreenSize } from "../../styles/media-queries";

export interface IAppModalProps {
  className?: string;
  dimBg?: boolean;
}
export default function AppModal({ className, dimBg = true, children, ...rest }: IAppModalProps) {
  const { phone } = useScreenSize();
  return (
    <Modal
      // className={`${className} inset-0 z-20 transition-background ${dimBg ? 'bg-modal-dim' : 'bg-transparent'} flex items-center justify-center `} contentLabel="Example Modal"
      parentSelector={() => document.querySelector("#main")}
      overlayClassName={`${className} ${
        dimBg ? "bg-modal-dim" : "bg-transparent"
      } z-20 absolute backdrop-blur-sm flex h-full items-center justify-center left-0 top-0 w-full`}
      className="flex justify-center md:w-2/3 z-20 outline-none"
      shouldCloseOnOverlayClick
      {...rest}
      closeTimeoutMS={400}
    >
      <div
        style={{ minWidth: phone ? 0 : 550, borderRadius: 16, width: "100%", maxWidth: 900 }}
        className=" shadow-lg focus-within:outline-2 outline-light-gray bg-bgpassive z-10 py-6 px-8"
      >
        {children}
      </div>
    </Modal>
  );
}
